module.exports = __webpack_public_path__ + "img/Draw-protect-icon_2.363ebdba.jpg";